import type { GroupedFilterHeadingProps } from './GroupedFilterHeading.typed';
import * as Styled from './GroupedFilterHeading.styled';
import type { ReactNode } from 'react';
import { shouldShowTrims } from '../../../../../components/SearchPage/features/makeModel/MakeModel.constants';

const GroupedFilterHeading = (props: GroupedFilterHeadingProps) => {
  const { filter, sectionName } = props;
  const iconMap: Record<string, ReactNode> = {
    new: (
      <Styled.NewText
        forwardedAs="span"
        size="B12"
        color="GREY_DARKER"
        weight="bold"
        aria-label="New Feature Icon"
      >
        NEW
      </Styled.NewText>
    ),
  };

  const { leadingIcon, trailingIcon } = filter;
  const leadingIconEl = leadingIcon && iconMap[leadingIcon?.name];
  const trailingIconEl = trailingIcon && iconMap[trailingIcon?.name];

  // TODO:This isn't ideal, Make this backend driven.
  // If the API is updated now, the title will be incorrect.
  // We should merge this before after go live and come back and tidy up.
  // https://github.com/distilledmedia/dsch-dd-filters/pull/451/files

  const headerName = () => {
    if (filter?.name === 'makeModel' && shouldShowTrims(sectionName)) {
      return 'Make, Model & Trim';
    }
    return filter?.displayName ?? '';
  };
  return (
    <Styled.IconTitle
      forwardedAs="span"
      size="B18"
      weight="bold"
      data-testid="grouped-filter-heading"
    >
      {leadingIconEl} {headerName()} {trailingIconEl}
    </Styled.IconTitle>
  );
};

export { GroupedFilterHeading };
